module.exports = global.config = {
    lang: "fr"
};